import { Listbox as SelectBase } from "@headlessui/react"; // cspell:disable-line
import { cn } from "@mozioinc/ui";
import { FaCaretDown } from "react-icons/fa";
import { Label } from "./label";
import { ListBox } from "./list-box";
import { Loading } from "./loading";
import type { ReactNode } from "react";

export type SelectProps = {
  options: { value: string; content: ReactNode }[];
  label: string;
  placeholder?: string;
  value?: string;
  noOptionsText?: ReactNode;
  loading?: boolean;
  className?: string;
  name?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
};

export const Select = (props: SelectProps) => {
  const {
    value,
    options,
    label,
    name,
    placeholder,
    noOptionsText = "No options",
    className = "",
    loading = false,
    onChange = () => {},
    onBlur = () => {},
  } = props;

  const selectedOptionContent = options.find((o) => o.value === value)?.content;

  return (
    <div
      className={`relative w-72 text-sm font-medium text-slate-700 ${className}`}
    >
      <SelectBase value={value} onChange={onChange} name={name}>
        <div className="grid">
          <SelectBase.Label as={Label}>{label}</SelectBase.Label>
          <SelectBase.Button
            className="relative cursor-default rounded-b bg-white py-2 pl-3 pr-10 text-left"
            onBlur={onBlur}
          >
            <span
              className={cn(
                "block truncate empty:before:inline-block empty:before:content-['']",
                {
                  "text-gray-400":
                    !selectedOptionContent && Boolean(placeholder),
                },
              )}
            >
              {selectedOptionContent || placeholder}
            </span>
            <span className="absolute inset-y-0 right-2 grid cursor-pointer place-items-center p-2">
              <FaCaretDown className="text-slate-500 duration-200 hover:brightness-95" />
            </span>
          </SelectBase.Button>
        </div>

        <ListBox.Transition>
          <SelectBase.Options as={ListBox}>
            {loading && <Loading className="py-2" color="primary" />}
            {!loading && options.length === 0 && (
              <ListBox.NoOption>{noOptionsText}</ListBox.NoOption>
            )}
            {!loading &&
              options.map((option) => (
                <SelectBase.Option
                  as={ListBox.Option}
                  key={option.value}
                  value={option.value}
                >
                  {option.content}
                </SelectBase.Option>
              ))}
          </SelectBase.Options>
        </ListBox.Transition>
      </SelectBase>
    </div>
  );
};
